<template>
  <div>
    <!--    <steps-order-->
    <!--      :step=5-->
    <!--    ></steps-order>-->

    <section class="invoice">
      <div class="overlay ModalOverlay" style="background: rgba(255, 255, 255, 1);" v-if="loading">
        <i class="fa fa-refresh fa-spin"></i>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h2 class="page-header">
            <i class="fa fa-shopping-cart"></i>
            Commande confirmée
          </h2>
        </div>
      </div>
      <!-- Table row -->
      <div class="row choixModePayement">
        <div class="col-md-12">
          <div class="info-box">
            <span class="info-box-icon bg-green"><i
              class="fa fa-check"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">Félicitations! Votre commande a été validée.</span>
              <span class="info-box-number">Dés réception de votre payement, votre commande sera traitée dans les plus brefs délais</span>
              <span class="info-box-more">Vous recevrez prochainement un mail récapitulatif concernant votre commande.</span>
            </div>
          </div>
        </div>

        <div class="col-md-12" v-if="infos">
          <div class="text-center" style="padding-top:25px;padding-bottom:25px; border-bottom:1px solid #E9E9E9;"><u>Vous avez choisi de payer par virement bancaire:</u> <br>
            Nous vous invitons à régler la somme de <strong>{{ infos.total }}€</strong>
            sur le compte <br><strong>{{ infos.iban }}</strong> <br>
            avec la communication suivante:<br> <strong>{{ infos.communication_structuree }}</strong></div>
        </div>
      </div>

      <div class="row no-print">
        <!--<div class="col-xs-12">-->
        <!--<router-link :to="{name: 'Confirm'}">-->
        <!--<a type="button" class="btn btn-primary pull-right">-->
        <!--<i class="fa fa-credit-card"></i>-->
        <!--Confirmer ce moyen de payement-->
        <!--</a>-->
        <!--</router-link>-->
        <!--</div>-->
        <div class="col-xs-12">
          <small class="">Une question? Une remarque? <br>Contactez-nous par téléphone au <strong>02/347.34.77</strong> ou par mail à l'adresse <strong>
            <a href="mailto:'secretariat@abft.be'">secretariat@abft.be</a></strong></small>
        </div>
        <div class="col-xs-12">
          <button @click.prevent="goToOrderList()" type="button" style="margin-top: 25px;" class="btn btn-primary pull-right ">
            <i class="fa fa-credit-card"></i>
            Vers vos commandes
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import Auth from '@/auth'
import {mapGetters, mapActions} from 'vuex'
import stepsOrder from '../stepsOrder'

let _ = require('lodash')

export default {
  data() {
    return {
      loading: true,
      infos: null
    }
  },

  mounted: async function () {
    //Si bancontact
    if (this.getModePayement == 'payementElectronique' && this.getSousModePayement == 'bancontact') {
      this.updateOrder().then(() => {
        this.infos=null
        this.loading = false
        this.resetOrder()
      }, (error) => {
        this.$noty.error("Erreur lors du payement de votre commande. ERR401")
        this.loading = false
        this.$router.push({name: 'FailingOrder'})
      })
    }
    //Si c'est un payement par carte
    else if (this.getModePayement == 'payementElectronique' && this.getSousModePayement == 'card') {
      this.updateOrder().then(() => {
        this.infos=null
        this.loading = false
        this.resetOrder()
      }, (error) => {
        this.$noty.error("Erreur lors du payement de votre commande. ERR403")
        this.loading = false
        this.$router.push({name: 'FailingOrder'})
      })
    }
    //Si c'est un virement
    else if (this.getModePayement == "virement") {
      await this.updateOrder().then((response) => {
        this.infos = {
          total: response.body.total,
          communication_structuree: response.body.communication_structuree,
          iban: response.body.iban,
        }
        this.loading = false
        this.resetOrder()
      }, (error) => {
        this.loading = false
        this.$router.push({name: 'FailingOrder'})
      })
    } else {
      this.loading = false
      this.$router.push({name: 'FailingOrder'})
    }
  },
  methods: {
    ...mapActions({
      setOrderPayed: 'setOrderPayed',
      resetOrder: 'resetOrder',
    }),
    updateOrder: async function () {
      return this.$http.post(process.env.API_URL + "processOrder", {
        id_club: this.getIdClubSelected,
        id_order: this.getIdOrder
      })
    },
    goToOrderList: function () {
      this.$router.push({
        name: 'OrderList',
      })
    },
    goToConfirmation: function () {
      this.setOrderPayed(true)
      this.$router.push({name: 'Confirm'})
    },
  },
  components: {
    stepsOrder
  },
  computed: {
    ...mapGetters({
      getCart: 'getCart',
      getOrder: 'getOrder',
      getAbft: 'getAbft',
      getIdOrder: 'getIdOrder',
      getModePayement: 'getModePayement',
      getSousModePayement: 'getSousModePayement',
      getStripeObject: 'getStripeObject',
      getStripeClientSecretToken: 'getStripeClientSecretToken',
      getIdClubSelected: 'getIdClubSelected',
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Order/CongratsOrder.vue